








































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import {
  CreateItemModal,
  InfiniteScroll,
  ItemTile,
  NetworkErrorEmptyState,
  VsLoading
} from '@/components'

import { EmptyState, MobileLayout } from '@/layouts/components'

import {
  AsyncState,
  Item,
  ItemGroup,
  ModalState
} from '@/models'

import { ItemGroupItems } from '@/store/menu/state'
import { RelationMap } from '@/store/models'
import { RootState } from '@/store/state'
import { isFood } from '@/utils'

@Component({
  components: {
    CreateItemModal,
    EmptyState,
    InfiniteScroll,
    ItemTile,
    MobileLayout,
    NetworkErrorEmptyState,
    VsLoading
  }
})
export default class Items extends Vue {
  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  loadState = new AsyncState()
  createState = new ModalState()

  get itemGroup (): ItemGroup | null {
    return this.itemGroupById(this.itemGroupId)
  }

  get itemGroupItems (): ItemGroupItems | undefined {
    return this.itemGroupsItems[this.itemGroupId]
  }

  get items () {
    return this.orderedItems(this.itemGroupId)
  }

  get showFab () {
    return this.total > 0 || this.loadState.isResolved
  }

  get title () {
    if (this.itemGroup !== null) {
      return this.itemGroup.title
    }

    return this.loadState.isPending
      ? null
      : 'Produtos'
  }

  get total () {
    return this.itemGroupItems
      ? this.itemGroupItems.total
      : 0
  }

  get emptyStateText () {
    return isFood() ? 'Cardápio' : 'Catálogo'
  }

  get emptyStateIcon () {
    return isFood() ? 'restaurant_menu' : 'list_alt'
  }

  @State((state: RootState) => state.menu.itemGroups.items)
  readonly itemGroupsItems!: RelationMap<ItemGroupItems>

  @Getter('menu/itemGroupById')
  readonly itemGroupById!: (id: number) => ItemGroup | null

  @Getter('menu/orderedItems')
  readonly orderedItems!: (itemGroupId: number) => Item[]

  @Action('menu/loadItemPage')
  loadItemPage!: (itemGroupId: number) => Promise<void>

  created () {
    if (this.total === 0) {
      this.reload()
    } else {
      this.loadState.touch()
    }
  }

  async reload () {
    try {
      await this.loadMore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async loadMore () {
    await this.loadState.handle(
      this.loadItemPage(this.itemGroupId)
    )

    return this.items.length > 0
  }
}
